import { HugeiconsIcon } from "@hugeicons/react";
import {
  AiAudioIcon,
  AnalysisTextLinkIcon,
  Backpack03Icon,
  DashboardSquare02Icon,
  File01Icon,
  Hotel01Icon,
  Location01Icon,
  NewOfficeIcon,
  NewsIcon,
  PackageDimensionsIcon,
  RocketIcon,
  Target02Icon,
  UserSharingIcon,
} from "@hugeicons/core-free-icons";
const Menu = [
  {
    id: 1,
    name: "Dashboard",
    icon: <HugeiconsIcon icon={DashboardSquare02Icon} />,
    path: "/admin/dashboard",
  },
  {
    id: 2,
    name: "All Bookings",
    icon: <HugeiconsIcon icon={RocketIcon} />,
    children: [
      {
        id: 1,
        name: "Hotel Bookings",
        path: "/admin/order/hotels",
      },
      {
        id: 2,
        name: "Tour Bookings",
        path: "/admin/order/tours",
      },
    ],
  },
  {
    id: 2,
    name: "Marketing",
    icon: <HugeiconsIcon icon={Target02Icon} />,
    children: [
      {
        id: 1,
        name: "Templates",
        path: "/admin/templates",
      },
      {
        id: 2,
        name: "Coupons",
        path: "/admin/coupons",
      },
      {
        id: 3,
        name: "Offers",
        path: "/admin/offers",
      },
      {
        id: 4,
        name: "Create Offer",
        path: "/admin/offer/create",
      },
    ],
  },
  {
    id: 3,
    name: "Blog",
    icon: <HugeiconsIcon icon={NewsIcon} />,
    children: [
      {
        id: 1,
        name: "Blogs",
        path: "/admin/blogs",
      },
      {
        id: 2,
        name: "Create Blog",
        path: "/admin/blog/create",
      },
      {
        id: 3,
        name: "Categories",
        path: "/admin/blog/categories",
      },
    ],
  },
  {
    id: 3,
    name: "Pages",
    icon: <HugeiconsIcon icon={PackageDimensionsIcon} />,
    children: [
      {
        id: 1,
        name: "Home",
        path: "/admin/page/home",
      },
    ],
  },
  {
    id: 4,
    name: "Company",
    icon: <HugeiconsIcon icon={NewOfficeIcon} />,
    children: [
      {
        id: 1,
        name: "Add Company",
        path: "/admin/company/create",
      },
      {
        id: 2,
        name: "Companies",
        path: "/admin/companies",
      },
    ],
  },
  {
    id: 5,
    name: "Hotel Management",
    icon: <HugeiconsIcon icon={Hotel01Icon} />,
    children: [
      {
        id: 1,
        name: "Hotel List",
        path: "/admin/hotels",
      },
      {
        id: 2,
        name: "Create Hotel",
        path: "/admin/hotel/create",
      },
      {
        id: 3,
        name: "Rooms",
        path: "/admin/rooms",
      },
      {
        id: 4,
        name: "Create Rooms",
        path: "/admin/room/create",
      },
      {
        id: 3,
        name: "Facilities",
        path: "/admin/hotel/facilities",
      },
    ],
  },
  {
    id: 5,
    name: "Tour Management",
    icon: <HugeiconsIcon icon={Backpack03Icon} />,
    children: [
      {
        id: 1,
        name: "Tours",
        path: "/admin/tours",
      },
      {
        id: 2,
        name: "Create Tour",
        path: "/admin/tour/create",
      },
    ],
  },
  {
    id: 6,
    name: "Report Management",
    icon: <HugeiconsIcon icon={AnalysisTextLinkIcon} />,
    children: [
      { id: 1, name: "Hotel Booking Report", path: "/admin/report/hotels" },
      {
        id: 2,
        name: "Tour Booking Report",
        path: "/admin/report/tours",
      },
    ],
  },
  {
    id: 6,
    name: "User Management",
    icon: <HugeiconsIcon icon={UserSharingIcon} />,
    children: [
      { id: 1, name: "Admin List", path: "/admin/user/admins" },
      {
        id: 2,
        name: "Customer List",
        path: "/admin/users",
      },
    ],
  },
  {
    id: 7,
    name: "File Manager",
    icon: <HugeiconsIcon icon={File01Icon} />,
    path: "/admin/file-manager",
  },
  {
    id: 8,
    name: "Automation",
    icon: <HugeiconsIcon icon={AiAudioIcon} />,
    path: "/admin/automation/chat",
    children: [
      {
        id: 1,
        name: "Website Chat",
        path: "/admin/automation/admin",
      },
    ],
  },
  {
    id: 8,
    name: "Location",
    icon: <HugeiconsIcon icon={Location01Icon} />,
    path: "/admin/Location",
  },
];

export default Menu;
